import React, { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { CheckCircle, XCircle, Edit, Image, HardDrive, FileText } from "react-feather"
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Dropzone from 'react-dropzone-uploader';
import { getSettings} from '../../store/settingsSlice';
import NoImage from '../../assets/images/noimage.png';
import SettingsTableModel from './SettingsTableModel';

const SettingsTable = () => {
  const storeVar = useSelector(state => state.settings)
  const dispatch = useDispatch();
  const [stateStatus, setStateStatus] = useState('ACTIVE');
  const [submit, setSubmit] = useState(false);
  const [formVar, setFormVar] = useState({
    settingIdURL: null,
    settingFile: null,
    settingIdImage: null,
    imageStatus: null,
  });

  useEffect(() => {
    dispatch(getSettings());
  }, []);


  return (
    <Fragment>
      <SettingsTableModel props={storeVar.settingsData}/>
    </Fragment>
  );
};

export default SettingsTable;
